import { createFileRoute } from '@tanstack/react-router';
import { QuoteEditorPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/quotes/$id')({ component: QuoteEditorPage });
